import { render, staticRenderFns } from "./changePwd.vue?vue&type=template&id=27e3b6cc&scoped=true&"
import script from "./changePwd.vue?vue&type=script&lang=js&"
export * from "./changePwd.vue?vue&type=script&lang=js&"
import style0 from "./changePwd.vue?vue&type=style&index=0&id=27e3b6cc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e3b6cc",
  null
  
)

export default component.exports